import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { uxSharedApi } from "./api";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { toast } from "@shared/hooks/use-toast";
import { queryClient } from "@shared/api/queries/queryClient";

export const useGetChoices = (name: string,context?:string) => {
  const remoteUtilityId = useRemoteUtilityId();
  return useSmartQuery(QueryKeyFactory.module.ux.choicesList(name), () =>
    uxSharedApi.getChoices(name, remoteUtilityId,context)
  );
};

export const useWorkflowsData = (id: any,name:string) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.workflowsData(id,name),
    () => uxSharedApi.getWorkflowsData(id,name),
    {
      enabled: !!id,
    }
  );
};

export const useCreateNote = () => {
  return useSmartMutation((payload: any) => uxSharedApi.createNote(payload), {
    onSuccess: () => {
      toast({
        title: "Note created successfully!",
        variant: "default",
      });

      const key = QueryKeyFactory.module.ux.notesList().slice(0, 4);

      queryClient.invalidateQueries({
        queryKey: key,
      });
    },
  });
};

export const useGetNotes = (id: string, type: string) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.notesList(id, type),
    () => uxSharedApi.getNotes(id, type)
  );
};

export const useGetActivityLog = (id: string, type: string) => {
  return useSmartQuery(
    QueryKeyFactory.module.ux.activityLogList(id, type),
    () => uxSharedApi.getActivityLog(id, type)
  );
};
